import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UserInfos } from "./user-infos.type";
import { MatTooltipModule } from "@angular/material/tooltip";


@Component({
    selector: "username-icon",
    templateUrl: "./username-icon.component.html",
    styleUrls: ["./username-icon.component.scss"],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        MatTooltipModule
    ]
})
export class UsernameIconComponent {

    @Input() userInfos: UserInfos;
    @Input() context: 'menu' | 'thread' | 'threadInput';

    constructor() { }


}




